<template>
	<div class = "box">
		<!-- <OrderCode :status = "orderDetail.status" :takeFoodCode = "orderDetail.takeFoodCode"></OrderCode> -->
		<div class="his-order-close-timer shop-location-div" v-if="orderDetail.status == 0  && getCloseTime(orderDetail.createdTime)>0">
			<van-count-down :time="getCloseTime(orderDetail.createdTime)" format="mm分ss秒后失效" />
		</div>
		<div class = "shop-detail-div">
			<ComShopLocation :shopName="orderDetail.storeName" :shopAddress="orderDetail.address" ></ComShopLocation>
		</div>
		<div class = "shop-pay-goods-div">
			<OrderGoods :orderDetail = "orderDetail"></OrderGoods>
		</div>
		<PayCoupon></PayCoupon>
		
		
		<div class = "pay-money-div">
			<van-row type="flex" justify="space-between">
			  <van-col span="14">
				  <div class = "pay-money-detail">
					  <span>合计：¥</span>
					  <span>{{parseFloat(orderPrice+'').toFixed(2)}}</span>
				  </div>
			  </van-col>
			  <van-col span="10">
				  <div class = "pay-btn">
					  <van-button round :color="this.$enum.CONSTANT.APP_THEME_COLOR" @click="openPayType()">确认支付</van-button>
				  </div>
			  </van-col>
			</van-row>
		</div>
		<van-action-sheet v-model="showPayType" :round="false" :closeable="false">
			<PayType orderId="" :code="code" ref="payTypeRef"></PayType>
		</van-action-sheet>
		<!-- <div class="emtry-div"></div> -->
		<!-- <ComTabbar></ComTabbar> -->
	</div>
</template>

<script>
	import { getOrderById } from '@/request/api';
	import OrderCode from '../components/orderDetail/OrderCode.vue'
	import ComTabbar from '../components/orderDetail/ComTabbar.vue'
	import ComShopLocation from '../components/goods/ComShopLocation.vue'
	import PayCoupon from '../components/pay/PayCoupon.vue'
	import OrderGoods from '../components/orderDetail/OrderGoods.vue'
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	import {
	
		CountDown,

	} from 'vant';
	export default {
		name: 'PayOrderDetail',
		computed: mapGetters(["sOrderId"]),
		components: {
		      [OrderCode.name]: OrderCode,
		      [PayCoupon.name]: PayCoupon,
		      [ComShopLocation.name]: ComShopLocation,
		      [OrderGoods.name]: OrderGoods,
		      [ComTabbar.name]: ComTabbar,
			  [CountDown.name]: CountDown,
		      
		 },
		 created(){
			 this.pollGetOrder()
		 },
		data(){
			return {
				orderDetail:'',
				orderTimer:'',
				orderId:''
			}
		},
		methods:{
			
			getCloseTime(createdTime) {
				let now = new Date().getTime();
				createdTime = new Date(Date.parse(createdTime.replace(/-/g, "/"))).getTime();
				return 10 * 60 * 1000 - (now - createdTime)
			},
			pollGetOrder(){
				let orderId = this.$route.params.orderId;
				if(!orderId){
					orderId = this.sOrderId;
				}
				this.orderId = orderId;
				this.getOrder();
				// this.orderTimer = setInterval(this.pollTimer, 3000);
			},
			getOrder(){
				getOrderById({
					id:this.orderId
				}).then(res => {
					// if(this.orderDetail){
					// 	this.orderDetail.status = res.status;
					// 	this.orderDetail.takeFoodCode = res.takeFoodCode;
					// }else{
					// 	this.orderDetail = res
					// }
					this.orderDetail = res
					// console.log(res)
				})  
			},
			//定时器-订单相关
			pollTimer(){
				if(this.orderDetail.status >= 3){
					this.stopOrderTimer();
				}else{
					this.getOrder(this.orderId);
				}
			},
			stopOrderTimer(){
				clearInterval(this.orderTimer);
			}
			
			
			
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		min-height: 100%;
		background-color: #f5f5f5;
		padding: 10px;
	}
	
	.shop-detail-div,.shop-pay-goods-div {
		margin-top: 10px;
		
	}
	.emtry-div {
		width: 100%;
		height: 70px;
	}
	.his-order-close-timer{
		padding: 0 8px;
	}
	
</style>
